
export { GGUSection } from "/codebuild/output/src3838206175/src/packages/shared-components/src/campaign/GGUSection.tsx"